import { getAmpConfig } from 'shared/config/amp-config';

export const getInsightServiceUrl = () => `${getAmpConfig().gateway}/insights`;

export const BOOST_EM_INSIGHT_TYPE = 'boost-em-recommendations';
